<!--
  Root template of the dunning type object component. It branches on the ui mode only; everything
  else lives in the two view components. The `initialized && dto` guard is mandatory — before that
  there is no dto to bind.

  `handleNavigationItems($event)` forwards the left navigation the view component declares up to the
  page frame, which renders it and writes the selected action into `?navItem=`.
-->
@if (initialized && dto) {

    @if (uiMode == 'side' || uiMode == 'mini-side') {

        <bd-dunning-type-side
                [objectIdentifier]="objectIdentifier"
                [dto]="dto"
                [uiMode]="uiMode"
                (onNavigationItems)="handleNavigationItems($event)">
        </bd-dunning-type-side>

    } @else {

        <bd-dunning-type-full
                [objectIdentifier]="objectIdentifier"
                [dto]="dto"
                [uiMode]="uiMode"
                (onNavigationItems)="handleNavigationItems($event)">
        </bd-dunning-type-full>

    }

} @else {

    <div class="flex align-items-center justify-content-center p-4">
        <p-progressSpinner strokeWidth="4" [style]="{width: '50px', height: '50px'}"></p-progressSpinner>
    </div>

}
